export const FORM_ASK_FOR = {
  askForForm: document.querySelector('#aafp_askfor-form') as HTMLFormElement,
  askForCG: document.querySelector('#aafp_askfor-card-group') as HTMLInputElement,
  askForResults: document.querySelector('.aafp_askfor-list-results') as HTMLElement,
  askForAvail: document.querySelector('.aafp_askfor-list-available') as HTMLElement,
  askForAddNew: document.querySelector('#aafp_add-askfor') as HTMLElement,
  askForCardGroupText: document.querySelector('#aafp_form-cg-name') as HTMLInputElement
}

export const FORM_ASK_FOR_VALIDATE = {
  validationTitle: document.querySelector('.askfor_validation-title') as HTMLElement,
  validateForm: document.querySelector('#aafp_ask-for-val') as HTMLFormElement,
  askForDropArea: document.querySelector('.aafp_box') as HTMLElement,
  askFormInputLabel: document.querySelector('.aafp_askfor-file-label') as HTMLElement,
  askForFileInput: document.querySelector('.aafp_askfor-file') as HTMLInputElement,
  askForFileError: document.querySelector('.aafp_askfor-error') as HTMLElement,
  askForValidationValues: document.querySelector('#aafp_form-validation-values') as HTMLInputElement,
  validateSubmit: document.querySelector('#aafp_validation-submit') as HTMLElement
}